var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "correction 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.589 10.4366C53.5332 10.7734 40.9554 1.6502 32.2552 1.8147C23.555 1.9792 5.37123 7.32414 6.12062 47.3525C6.87 87.3808 31.5633 92.7963 41.1356 92.6187C85.9501 91.7805 103.57 9.83864 71.589 10.4366Z",
    fill: "#EFEFEF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.3889 76.3751C59.1702 76.3751 71.1528 64.3925 71.1528 49.6112C71.1528 34.8299 59.1702 22.8473 44.3889 22.8473C29.6076 22.8473 17.625 34.8299 17.625 49.6112C17.625 64.3925 29.6076 76.3751 44.3889 76.3751Z",
    fill: "#2ECC71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9778 49.6112C22.9778 35.7331 33.5423 24.3252 47.0653 22.9831C46.1853 22.8943 45.2923 22.8473 44.3889 22.8473C29.6074 22.8473 17.625 34.8297 17.625 49.6112C17.625 64.3927 29.6074 76.3751 44.3889 76.3751C45.2923 76.3751 46.1853 76.3281 47.0653 76.2393C33.5423 74.8972 22.9778 63.4892 22.9778 49.6112Z",
    fill: "#129E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.1709 78.4628L77.0172 76.6165L80.7099 80.3092L78.8636 82.1555L75.1709 78.4628Z",
    fill: "#A4AFC1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M75.6343 69.6718L79.3269 65.9791L81.1733 67.8254L77.4806 71.5181L75.6343 69.6718Z",
    fill: "#A4AFC1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65.0195 80.2886L68.7122 76.596L70.5585 78.4423L66.8659 82.135L65.0195 80.2886Z",
    fill: "#A4AFC1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M70.5002 18.3222C68.3408 18.3222 66.5835 16.5649 66.5835 14.4056C66.5835 12.2462 68.3408 10.4889 70.5002 10.4889C72.6596 10.4889 74.4168 12.2462 74.4168 14.4056C74.4168 16.5649 72.6596 18.3222 70.5002 18.3222ZM70.5002 13.1C69.7795 13.1 69.1946 13.6875 69.1946 14.4056C69.1946 15.1236 69.7795 15.7111 70.5002 15.7111C71.2208 15.7111 71.8057 15.1236 71.8057 14.4056C71.8057 13.6875 71.2208 13.1 70.5002 13.1Z",
    fill: "#A4AFC1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "regular"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.3887 78.3333C28.5523 78.3333 15.6665 65.4475 15.6665 49.6111C15.6665 33.7747 28.5523 20.8889 44.3887 20.8889C49.8982 20.8889 55.2562 22.4607 59.8831 25.4296L57.7654 28.7248C53.7731 26.1633 49.1462 24.8055 44.3887 24.8055C30.7117 24.8055 19.5832 35.9341 19.5832 49.6111C19.5832 63.2881 30.7117 74.4166 44.3887 74.4166C58.0657 74.4166 69.1943 63.2881 69.1943 49.6111C69.1943 48.7938 69.1551 47.9844 69.0794 47.188L72.9778 46.8094C73.0666 47.7337 73.111 48.6659 73.111 49.6111C73.111 65.4475 60.2251 78.3333 44.3887 78.3333Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.6524 56.1389C47.1511 56.1389 46.6498 55.9483 46.2686 55.5645L34.5186 43.8145L37.2889 41.0441L47.6551 51.4102L74.9908 24.0745L77.7612 26.8449L49.0389 55.5671C48.6551 55.9483 48.1538 56.1389 47.6524 56.1389Z",
    fill: "black"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b1e31ba4cf25121442f70ae0d533679f.svg";
export { ForwardRef as ReactComponent };